module.exports = __webpack_public_path__ + "../resources/img/undo.5246b9e3.png";